// Global JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Close cart drawer when clicking overlay
  const cartOverlay = document.querySelector('.cart-drawer__overlay');
  if (cartOverlay) {
    cartOverlay.addEventListener('click', closeCartDrawer);
  }
  
  // Close cart drawer with close button
  const closeBtn = document.querySelector('.cart-drawer__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeCartDrawer);
  }
  
  // Add to cart forms
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', handleAddToCart);
  });
});

function closeCartDrawer() {
  const cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    cartDrawer.classList.remove('active');
    document.body.style.overflow = '';
  }
}

function openCartDrawer() {
  const cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    cartDrawer.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
}

async function handleAddToCart(e) {
  e.preventDefault();
  const form = e.target;
  const formData = new FormData(form);
  
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });
    
    if (response.ok) {
      await updateCartCount();
      await refreshCartDrawer();
      openCartDrawer();
    } else {
      alert('Error adding item to cart');
    }
  } catch (error) {
    console.error('Error:', error);
    alert('Error adding item to cart');
  }
}

async function updateCartCount() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const countElement = document.getElementById('cart-count');
    if (countElement) {
      countElement.textContent = cart.item_count;
    }
  } catch (error) {
    console.error('Error updating cart count:', error);
  }
}

async function refreshCartDrawer() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    
    const currentContent = document.getElementById('cart-drawer-content');
    if (!currentContent) return;
    
    // Build cart HTML based on cart data
    if (cart.item_count > 0) {
      let itemsHTML = '<div class="cart-items">';
      
      cart.items.forEach((item, index) => {
        itemsHTML += `
          <div class="cart-item">
            <div class="cart-item__image">
              ${item.image ? `<img src="${item.image}" alt="${item.title}" width="100">` : ''}
            </div>
            <div class="cart-item__details">
              <div class="cart-item__title">${item.product_title}</div>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
              <div class="cart-item__price">${formatMoney(item.final_price)}</div>
            </div>
            <div class="cart-item__quantity">
              <select data-line="${index + 1}" 
                      onchange="updateCartQuantity(this)"
                      style="padding: 8px 12px; border: 1px solid #e0e0e0; border-radius: 4px; font-size: 14px; cursor: pointer; min-width: 70px;">
                ${[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20].map(i => 
                  `<option value="${i}" ${item.quantity === i ? 'selected' : ''}>${i}</option>`
                ).join('')}
                <option value="custom" ${item.quantity > 20 ? 'selected' : ''}>
                  ${item.quantity > 20 ? item.quantity + '+' : '20+'}
                </option>
              </select>
            </div>
            <button type="button" 
                    class="cart-item__remove" 
                    data-line="${index + 1}"
                    onclick="removeCartItem(this)"
                    aria-label="Remove item"
                    style="background: transparent; border: none; cursor: pointer; padding: 8px; margin-left: 8px;">
              <svg width="16" height="16" viewBox="0 0 20 20" fill="none">
                <path d="M15 5L5 15M5 5L15 15" stroke="#999" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        `;
      });
      
      itemsHTML += `
        </div>
        <div class="cart-drawer__footer">
          <div class="cart-drawer__total">
            <span>Subtotal:</span>
            <span class="cart-drawer__total-price">${formatMoney(cart.total_price)}</span>
          </div>
          <a href="/cart" class="button button--secondary">View Cart</a>
          <button type="button" class="button button--primary" onclick="window.location.href='/checkout'">Checkout</button>
          <button type="button" onclick="clearCart()" style="display: flex; align-items: center; justify-content: flex-end; gap: 6px; margin-top: 12px; margin-left: auto; background: transparent; border: none; color: #999; font-size: 13px; cursor: pointer; padding: 0;">
            <svg width="14" height="14" viewBox="0 0 20 20" fill="none" style="flex-shrink: 0;">
              <path d="M15 5L5 15M5 5L15 15" stroke="#dc2626" stroke-width="2.5" stroke-linecap="round"/>
            </svg>
            <span>Clear Cart</span>
          </button>
        </div>
      `;
      
      currentContent.innerHTML = itemsHTML;
    } else {
      currentContent.innerHTML = `
        <div class="cart-empty">
          <p>Your cart is empty</p>
          <a href="/pages/shop" class="button">Continue Shopping</a>
        </div>
      `;
    }
  } catch (error) {
    console.error('Error refreshing cart:', error);
  }
}

// Helper function to format money
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// Clear all items from cart
async function clearCart() {
  if (!confirm('Are you sure you want to clear your cart?')) {
    return;
  }
  
  try {
    const response = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    
    if (response.ok) {
      await updateCartCount();
      await refreshCartDrawer();
    } else {
      alert('Error clearing cart');
    }
  } catch (error) {
    console.error('Error:', error);
    alert('Error clearing cart');
  }
}

// Remove single item from cart
async function removeCartItem(button) {
  const line = button.dataset.line;
  
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        line: line,
        quantity: 0
      })
    });
    
    if (response.ok) {
      await updateCartCount();
      await refreshCartDrawer();
    } else {
      alert('Error removing item');
    }
  } catch (error) {
    console.error('Error:', error);
    alert('Error removing item');
  }
}

// Expose functions globally
window.openCartDrawer = openCartDrawer;
window.closeCartDrawer = closeCartDrawer;
window.clearCart = clearCart;
window.removeCartItem = removeCartItem;
